import React, { useEffect } from 'react';

// DEPENDENCIES
import { compose } from 'redux';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';
import { NEW_USED_TYPES } from 'globals.js';

// GLOBAL HELPERS
import { withRouter } from 'helpers/withRouter';
import { useFormikContext } from 'formik';
import useRecordView from 'helpers/getRecordView';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';
import Card from 'parts/card/Card';
import Record from 'parts/record/Record';

// MAIN COMPONENT
const DealPackUpdate = () => (
  <Record.Update
    recordLabel="deal pack"
    endpoints={ENDPOINTS.admin.dealPacks}
    initialValues={{
      is_active: 1
    }}
  >
    <Card body={<FormBody />} />
  </Record.Update>
);

const FormBody = compose(withRouter)(({ location: { search } }) => {
  // CONTEXT
  const { isEdit } = useRecordView();
  const { values, setFieldValue } = useFormikContext() || {};
  const { sale_type_category_ids } = values || {};

  const params = new URLSearchParams(search);
  const newUsedParam = params.get('new_used');
  const newUsed = newUsedParam ? +newUsedParam : values?.new_used;
  const newUsedLabel = NEW_USED_TYPES[newUsed];

  useEffect(
    () => {
      if (!isEdit) setFieldValue('new_used', newUsed);
      else setFieldValue('sale_type_category_id', sale_type_category_ids);
    }, [isEdit, setFieldValue, newUsed, sale_type_category_ids]
  );

  return (
    <Form.Body>
      <Form.PlainText label="Type" value={newUsedLabel} />
      <Form.YesNo name="is_active" label="Active" required />
      <Form.Control name="pack_title" label="Title" required />
      <Form.Control name="pack_amount" label="Amount" schema="dollars" required />
      <Form.Checklist
        label="Sale Type"
        name="sale_type_category_id"
        lookup="salesTypeCategory"
        optionKeys={{
          label: 'sale_type_category_name',
          value: 'sale_type_category_id'
        }}
        list={{
          direction: 'horizontal'
        }}
        useNone
        useCSV
        toggleAll
        required
      />
      <Form.Textarea name="pack_description" label="Description" />
      <Record.Log />
    </Form.Body>
  );
});

// EXPORT
export default DealPackUpdate;
